/*
  Model for phone number update OTP flow.
  Exports:
   - sendOtpForPhoneUpdate(phone: string): Promise<any>
   - submitOtpForPhoneUpdate(phone: string, otp: string): Promise<any>

  NOTE: these functions use fetch and expect JSON responses. They throw an Error on non-2xx responses.
*/
export const SEND_OTP_URL = 'https://etl.futurisk.in/webhook/789c19b8-f318-46b8-af76-ad807f213a81'
export const SUBMIT_OTP_URL = 'https://etl.futurisk.in/webhook/71ef00dd-6130-4de4-98ac-b29221e5c1f5'

type Meta = {
  CRMClientId?: string | number | null
  EmployeeId?: string | number | null
}

type SendOtpPayload = {
  phoneNumber: string
} & Meta

type SubmitOtpPayload = {
  phoneNumber: string
  otp: string
} & Meta

async function postJson(url: string, body: object) {
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  })

  const text = await res.text()
  let data: any = text
  try {
    data = text ? JSON.parse(text) : null
  } catch (e) {
    // keep raw text
  }

  if (!res.ok) {
    const err = new Error(
      data && data.message ? data.message : `Request failed with status ${res.status}`
    )
    ;(err as any).status = res.status
    ;(err as any).response = data
    throw err
  }

  return data
}

export async function sendOtpForPhoneUpdate(
  phoneNumber: string,
  meta?: Meta
) {
  if (!phoneNumber) throw new Error('phoneNumber required')
  const payload: SendOtpPayload = {
    phoneNumber,
    CRMClientId: meta?.CRMClientId ?? null,
    EmployeeId: meta?.EmployeeId ?? null,
  }
  return postJson(SEND_OTP_URL, payload)
}

export async function submitOtpForPhoneUpdate(
  phoneNumber: string,
  otp: string,
  meta?: Meta
) {
  if (!phoneNumber) throw new Error('phoneNumber required')
  if (!otp) throw new Error('otp required')
  const payload: SubmitOtpPayload = {
    phoneNumber,
    otp,
    CRMClientId: meta?.CRMClientId ?? null,
    EmployeeId: meta?.EmployeeId ?? null,
  }
  return postJson(SUBMIT_OTP_URL, payload)
}

const DashboardPhoneModel = {
  sendOtpForPhoneUpdate,
  submitOtpForPhoneUpdate,
}

export default DashboardPhoneModel
